import { Link } from "react-router-dom";
import Seo from "@/components/feature/Seo";

const values = [
  {
    icon: "ri-flag-line",
    title: "客观中立",
    desc: "评分与推荐以作品质量为核心，不因商业因素而改变，坚持真实口碑。",
    color: "bg-primary-100 text-primary-700",
  },
  {
    icon: "ri-hand-heart-line",
    title: "尊重创作",
    desc: "本站为推荐与资讯平台，引导读者前往正版授权渠道，支持每一位创作者。",
    color: "bg-accent-100 text-accent-700",
  },
  {
    icon: "ri-lightbulb-flash-line",
    title: "内容创新",
    desc: "坚持输出原创漫评与创作干货，为读者和创作者提供真正有价值的内容。",
    color: "bg-secondary-100 text-secondary-700",
  },
  {
    icon: "ri-team-line",
    title: "共建共享",
    desc: "鼓励读者参与投稿与讨论，让樱花漫画成为属于大家的追漫社区。",
    color: "bg-primary-100 text-primary-700",
  },
];

const testimonials = [
  {
    name: "漫友·阿澈",
    text: "在这里找到了很多冷门好作品，编辑推荐的眼光真的准，评分也够客观。",
  },
  {
    name: "漫画作者·小满",
    text: "创作干货专栏对我的帮助很大，把分镜和节奏讲得非常清楚，受益匪浅。",
  },
  {
    name: "资深读者·一只猫",
    text: "每周的漫讯订阅很贴心，新作动态和专题推送都恰到好处，不会刷屏。",
  },
];

export default function About() {
  return (
    <>
      <Seo
        title="关于我们 - 樱花漫画"
        description="了解樱花漫画的品牌介绍、网站定位、发展理念与内容原则。我们是专注国产漫画推荐与资讯的平台，为每一部好作品找到懂它的读者。"
        canonical="https://comicflower.github.io/about"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "AboutPage",
          name: "关于樱花漫画",
          description: "樱花漫画的品牌介绍、发展理念与内容原则。",
        }}
      />
      <div className="mx-auto max-w-7xl px-4 pt-24 md:px-6 md:pt-28">
        <nav className="flex flex-wrap items-center gap-1 text-xs text-foreground-500" aria-label="面包屑">
          <Link to="/" className="hover:text-primary-700">首页</Link>
          <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
          <span className="text-foreground-800">关于我们</span>
        </nav>

        <div className="mt-8 grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-2 whitespace-nowrap text-xs font-medium uppercase tracking-widest text-primary-600">
              <span className="h-px w-6 bg-accent-500" aria-hidden="true"></span>
              关于我们
            </span>
            <h1 className="mt-3 font-heading text-3xl font-black leading-snug text-foreground-950 md:text-4xl md:leading-snug">
              让每一部好漫画，
              <br />
              都能遇见懂它的读者
            </h1>
            <p className="mt-5 text-sm leading-relaxed text-foreground-700">
              樱花漫画诞生于对国产漫画的一腔热爱。我们相信，一部用心创作的作品值得被更多人看见。因此，我们聚合热门漫画排行、作品分类、新作连载动态与深度专题文章，用客观评分与真实口碑，为读者提供一份可靠的追漫指南。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              网站坚持推荐与资讯的定位，不提供盗版或破解资源，而是引导读者前往正版授权渠道，用实际的付费支持守护每一位创作者。
            </p>
          </div>
          <div className="overflow-hidden rounded-2xl border border-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20illustration%20of%20a%20friendly%20team%20of%20young%20manga%20lovers%20gathered%20around%20a%20table%20reading%20and%20discussing%20comic%20books%20in%20a%20cozy%20library%20with%20sakura%20decorations%2C%20cups%20of%20tea%20and%20posters%20on%20walls%2C%20warm%20coral%20amber%20and%20green%20palette%2C%20welcoming%20editorial%20illustration%20style%2C%20high%20detail&width=1200&height=800&seq=about-team&orientation=landscape"
              alt="樱花漫画团队讨论漫画"
              className="w-full object-cover"
            />
          </div>
        </div>
      </div>

      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">我们的内容原则</h2>
        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((v) => (
            <div key={v.title} className="rounded-2xl border border-background-200 bg-background-100 p-6">
              <span className={`flex h-12 w-12 items-center justify-center rounded-xl ${v.color}`}>
                <i className={`${v.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{v.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">读者与作者的声音</h2>
          <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure key={t.name} className="rounded-2xl border border-background-200 bg-background-50 p-6">
                <i className="ri-double-quotes-l text-2xl text-accent-500" aria-hidden="true"></i>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                  {t.text}
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 font-heading text-base font-bold text-primary-700">
                    {t.name.slice(0, 1)}
                  </span>
                  <span className="text-sm font-medium text-foreground-900">{t.name}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="flex flex-col items-center justify-between gap-6 rounded-2xl bg-background-200 p-8 text-center sm:flex-row sm:text-left">
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950">想与我们合作或投稿？</h2>
            <p className="mt-2 text-sm text-foreground-600">欢迎来信交流，让我们把国漫推荐这件事做得更好。</p>
          </div>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 hover:bg-primary-600"
          >
            联系我们
            <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
          </Link>
        </div>
      </section>
    </>
  );
}